import { TopOfBookSourceUpdateRequest } from '@api/core';
import { EnumTranslation, getInvalidEnumTranslation, getSortedTranslations } from '@shared/enums/shared/enums.utils';
import { assertNever } from '@shared/utils/assertions';

export namespace TopOfBookSourceEnum {
  const values: readonly TopOfBookSourceUpdateRequest.TypeEnum[] = [
    TopOfBookSourceUpdateRequest.TypeEnum.BinanceSpot,
    TopOfBookSourceUpdateRequest.TypeEnum.BinancePerpetual,
    TopOfBookSourceUpdateRequest.TypeEnum.BybitSpot,
    TopOfBookSourceUpdateRequest.TypeEnum.BybitPerpetual,
    TopOfBookSourceUpdateRequest.TypeEnum.OkxSpot,
    TopOfBookSourceUpdateRequest.TypeEnum.OkxPerpetual,
    TopOfBookSourceUpdateRequest.TypeEnum.Aggregate,
    TopOfBookSourceUpdateRequest.TypeEnum.Multiply,
    TopOfBookSourceUpdateRequest.TypeEnum.Divide,
    TopOfBookSourceUpdateRequest.TypeEnum.PerpSpotChaining,
    TopOfBookSourceUpdateRequest.TypeEnum.LiquidityProvider,
    TopOfBookSourceUpdateRequest.TypeEnum.CoinbasePerpetual,
    TopOfBookSourceUpdateRequest.TypeEnum.KrakenSpot,
    TopOfBookSourceUpdateRequest.TypeEnum.CoinbaseSpot,
  ];

  export function translate(val: TopOfBookSourceUpdateRequest.TypeEnum): string {
    return toEnumTranslation(val).description;
  }

  export function getTranslatedOrderedValues(toTranslateAndOrder?: readonly TopOfBookSourceUpdateRequest.TypeEnum[]) {
    return getSortedTranslations(toTranslateAndOrder || values, toEnumTranslation);
  }

  const exchangeNames: readonly TopOfBookSourceUpdateRequest.TypeEnum[] = [
    TopOfBookSourceUpdateRequest.TypeEnum.BybitSpot,
    TopOfBookSourceUpdateRequest.TypeEnum.KrakenSpot,
    TopOfBookSourceUpdateRequest.TypeEnum.CoinbasePerpetual,
  ];

  export function getTranslatedOrderedExchangeNames() {
    return getSortedTranslations(exchangeNames, toEnumTranslation);
  }

  export function toEnumTranslation(val: TopOfBookSourceUpdateRequest.TypeEnum): EnumTranslation {
    switch (val) {
      case 'BINANCE_SPOT':
        return {
          description: 'Binance Spot',
          order: 0,
        };
      case 'BINANCE_PERPETUAL':
        return {
          description: 'Binance Perpetual',
          order: 1,
        };
      case 'BYBIT_SPOT':
        return {
          description: 'Bybit Spot',
          order: 2,
        };
      case 'BYBIT_PERPETUAL':
        return {
          description: 'Bybit Perpetual',
          order: 3,
        };
      case 'OKX_SPOT':
        return {
          description: 'OKX Spot',
          order: 4,
        };
      case 'OKX_PERPETUAL':
        return {
          description: 'OKX Perpetual',
          order: 5,
        };
      case 'AGGREGATE':
        return {
          description: 'Aggregate',
          order: 6,
        };
      case 'MULTIPLY':
        return {
          description: 'Multiply',
          order: 7,
        };
      case 'DIVIDE':
        return {
          description: 'Divide',
          order: 8,
        };
      case 'PERP_SPOT_CHAINING':
        return {
          description: 'Perp spot chaining',
          order: 9,
        };
      case 'LIQUIDITY_PROVIDER':
        return {
          description: 'Liquidity provider',
          order: 10,
        };
      case 'COINBASE_PERPETUAL':
        return {
          description: 'Coinbase Perpetual (Deprecated)',
          order: 11,
          deprecated: true,
        };
      case 'KRAKEN_SPOT':
        return {
          description: 'Kraken Spot',
          order: 12,
        };
      case 'COINBASE_SPOT':
        return {
          description: 'Coinbase Spot',
          order: 13,
        };
      default:
        return assertNever<EnumTranslation>(val, getInvalidEnumTranslation(val));
    }
  }
}
